import styled from 'styled-components';
import breakpointsMinWidth from '../styling/breakpointsMinWidth';
import { PrimaryDarkRGBA } from '../styling/theme';

export const Wrapper = styled.div`
  height: 48px;
  margin-top: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  grid-gap: 12px;
  border-radius: 0 0 4px 4px;
`;
export const Button = styled.span`
  display: flex;
  align-items: center;
  padding: 0 8px;
  cursor: pointer;
  height: 24px;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  background: #fff;
  border: 1px solid #9a9898;
  border-radius: 4px;

  &:hover {
    background: ${PrimaryDarkRGBA(0.1)};
  }
  @media ${breakpointsMinWidth.desktopMd} {
    font-size: 14px;
  }
`;
export const Hyperlink = styled.a`
  text-decoration: none;
  color: inherit;
  &:hover {
    color: inherit;
    text-decoration: none;
  }
`;

export const Wrappers = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  grid-gap: 8px;
  border-radius: 0 0 4px 4px;
`;
